export const Inventory = {
    SET_UPLOAD_ENTRIES: "inventory.upload.set",
    DELETE_UPLOAD_ROW: "inventory.upload.delete",
    UPDATE_UPLOAD_ROW: "inventory.upload.update",
    SET_UPLOAD_MODE: "inventory.upload.mode",
    MARK_REPLACING_UPLOAD_ROW: "inventory.upload.mark_replacing",
    START_ROW_EDIT: "inventory.edit.start",
    CANCEL_ROW_EDIT: "inventory.edit.cancel",
    APPLY_ROW_EDIT: "inventory.edit.apply",
    SET_EDITED_FIELD: "inventory.edit.field",
    NEW_INVENTORY: "inventory.new",
    NEW_INVENTORY_LIST: "inventory.new.list",
    REMOVE_INVENTORY: "inventory.remove",
    REMOVE_INVENTORY_LIST: "inventory.remove.list",
    UPDATE_INVENTORY_LIST: "inventory.update.list",
    MARKET_DATA_BATCH_UPDATE: "inventory.update.market_data_batch",
    APPLY_REF_RATE: "inventory.apply.ref_rate",
    APPLY_MATURITY: "inventory.apply.maturity",
    APPLY_INTERMEDIARY: "inventory.apply.intermediary",
    ERROR: "inventory.error",
    SET_SELECTED_INVENTORY: "inventory.set.selected",
};
